import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { UrlQueryHandlerService } from 'src/app/services/url-query-handler.service';
import { promiseWithCatch } from '../../app.helpers';
import ProjectLinks from '../../project.links';
import { GuardShared } from '../auth/guard.shared.abstract';

@Injectable()
export class UserNotLoggedGuard extends GuardShared {
  private urlQueryHandlerService: UrlQueryHandlerService = inject(UrlQueryHandlerService);

  protected checkGuard(_previousPage: string, route: ActivatedRouteSnapshot): boolean {
    if (this.isSessionActive()) {
      if (route && route.queryParams) {
        this.urlQueryHandlerService.proceedUrlQueryParams(route.queryParams);
      } else {
        promiseWithCatch(this.router.navigate([ProjectLinks.LINK_DEFAULT]));
      }
      return false;
    } else {
      return true;
    }
  }
}
